import React, {Component} from 'react';
import { Field } from 'redux-form';
import * as Form from './formFieldHelpers';
import * as Date from '../dates/dateHelpers';
import DateRange from '../dates/dateRange';
import * as Buttons from '../ui/buttons';

export default class ExperienceForm extends Component {

    componentDidMount = () => this.handleInitialise()

    handleInitialise = () => {
        const { personId, initialize, id, title, company, location, description, data, start_date, end_date, person_id } = this.props;

        const startMonth = Date.handleDates( start_date, end_date ).startMonth;
        const endMonth = Date.handleDates( start_date, end_date ).endMonth;

        initialize({
            "type": id ? "UPDATE" : "CREATE",
            "id": id,
            "person_id": ( data && data.personId ) || +personId || +person_id,
            "i_still_work_here": !!( start_date && ( end_date === undefined || end_date === null || end_date === 'Present' ) ),
            "title": title,
            "company": company,
            "location": location,
            "description": description,
            "start_month": {label: startMonth && startMonth.name, value: startMonth && startMonth.id },
            "start_year": {label: (Date.handleDates(start_date, end_date).startYear), value: (Date.handleDates(start_date, end_date).startYear) },
            "end_month": {label: endMonth && endMonth.name, value: endMonth && endMonth.id},
            "end_year": {label: (Date.handleDates(start_date, end_date).endYear), value: (Date.handleDates(start_date, end_date).endYear) },
        });
    };

    render() {
        const { buttonHandlers, data, start_date, end_date, type, onCancel, handleAdding } = this.props;
        const numberButtons = start_date && 3;

        return (
            <form className="form-standard-profile" id="experience-form" >
                <div className="row">
                    <div className="col-xs-12">
                        <Field
                            label="Job title"
                            name="title"
                            placeholder="Title"
                            component={ Form.textField }
                        />
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <Field
                            label="Company"
                            name="company"
                            placeholder="Company"
                            component={ Form.textField }
                        />
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <Field
                            label="Location"
                            name="location"
                            placeholder="Location"
                            component={ Form.textField }
                        />
                    </div>

                    <DateRange type={type} typeOf='work' start_date={start_date} end_date={end_date}/>

                    <div className="col-xs-12">
                        <Field
                            label="Description"
                            name="description"
                            placeholder="Description."
                            component={ Form.quill }
                        />
                    </div>
                        <div className="col-xs-12">
                            <Field
                                name="errors_on_form"
                                component={ Form.errorField }
                                hidden
                            />
                            <Buttons.HOCFormButtons
                                { ... data }
                                { ...this.props }
                                onCancel={ () => onCancel () }
                                handleAdding={ ( form ) => handleAdding ( form ) }
                                { ...buttonHandlers }
                                numberButtons={ numberButtons }
                            />
                        </div>
                    </div>
            </form>
        );
    }
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/forms/ExperienceForm.js